<div class="step-header">
  <div class="header-text">{{ headerText }}</div>
  <div class="header-text sub-header-text">{{ subHeaderText }}</div>
</div>

<dx-data-grid
  #contractSelectorDatagrid
  id="contracts-datagrid"
  class="gpd-datagrid"
  keyExpr="id"
  [dataSource]="siteContracts"
  [selectedRowKeys]="selectedContractIds"
  (onSelectionChanged)="onSelectionChanged($event)"
  columnResizingMode="widget"
  [allowColumnResizing]="true"
  width="100%"
  (onCellPrepared)="onCellPrepared($event)"
>
  <dxo-selection mode="multiple" selectAllMode="allPages"></dxo-selection>

  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxo-paging [enabled]="true"></dxo-paging>
  <dxo-pager
    [visible]="true"
    displayMode="full"
    [showPageSizeSelector]="false"
    [showInfo]="false"
    [showNavigationButtons]="true"
  ></dxo-pager>

  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxi-column
    dataField="designation"
    i18n-caption="@@designation"
    caption="Designation"
    [allowFiltering]="true"
  ></dxi-column>

  <dxi-column
    dataField="contractTypeId"
    i18n-caption="@@contractType"
    caption="Contract Type"
    allowFiltering="true"
  >
    <dxo-lookup [dataSource]="contractTypes" displayExpr="name" valueExpr="id"></dxo-lookup>
  </dxi-column>

  <dxi-column
    dataField="contractPartyIntern.displayName"
    i18n-caption="@@partyIntern"
    caption="Internal Party"
    allowFiltering="true"
  ></dxi-column>

  <dxi-column
    dataField="contractPartyExtern.displayName"
    i18n-caption="@@partyExtern"
    caption="External Party"
    [allowFiltering]="true"
  ></dxi-column>

  <dxi-column
    dataField="statusId"
    alignment="left"
    i18n-caption="@@status"
    caption="Status"
    width="110px"
    cellTemplate="cellTemplate"
  >
    <div *dxTemplate="let item of 'cellTemplate'">
      <app-status-pill [statusId]="item.data.statusId" [statusConfig]="contractStatusConfig"></app-status-pill>
    </div>
  </dxi-column>
</dx-data-grid>
